import { render } from "./FormFileList.vue?vue&type=template&id=651d3d1e"
import script from "./FormFileList.vue?vue&type=script&lang=js"
export * from "./FormFileList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__